// Normaliza o objeto recebido, porque endpoints diferentes podem devolver o alerta em formatos diferentes.
function getCurrentAlert(alert = {}) {
  // Alguns retornos vêm com o alerta dentro da chave `alert`.
  if (alert.alert) {
    return alert.alert;
  }

  // Outros retornos podem vir com o alerta dentro da chave `Alert`.
  if (alert.Alert) {
    return alert.Alert;
  }

  // Se não houver wrapper, o próprio objeto já é o alerta.
  return alert;
}

// Extrai a PO do alerta tentando os formatos conhecidos do sistema legado.
export function getAlertPO(alert = {}) {
  // Primeiro remove wrappers como `alert.alert` ou `alert.Alert`.
  const currentAlert = getCurrentAlert(alert);

  // Formato usado na tela de Alertas: alert.po.order_reference.
  if (currentAlert.po && currentAlert.po.order_reference) {
    return currentAlert.po.order_reference;
  }

  // Formato alternativo: alert.po_item.po.order_reference.
  if (currentAlert.po_item && currentAlert.po_item.po) {
    return currentAlert.po_item.po.order_reference;
  }

  // Formato alternativo em camelCase: alert.poItem.po.order_reference.
  if (currentAlert.poItem && currentAlert.poItem.po) {
    return currentAlert.poItem.po.order_reference;
  }

  // Alguns payloads podem trazer a PO direto dentro de po_item.
  if (currentAlert.po_item && currentAlert.po_item.order_reference) {
    return currentAlert.po_item.order_reference;
  }

  // Mesmo caso anterior, mas em camelCase.
  if (currentAlert.poItem && currentAlert.poItem.order_reference) {
    return currentAlert.poItem.order_reference;
  }

  // Última tentativa: a PO pode estar diretamente no próprio alerta.
  return currentAlert.order_reference ? currentAlert.order_reference : null;
}

// Conta alertas agrupando por PO, ou seja, múltiplos alertas da mesma PO contam como 1.
export function countGroupedAlertsByPO(alertList = []) {
  // Objeto usado como índice para registrar cada PO encontrada uma única vez.
  const groupedAlertsCounter = {};

  // Percorre todos os alertas recebidos.
  alertList.forEach(alert => {
    // Extrai a PO usando a função que entende os formatos possíveis do payload.
    const PO = getAlertPO(alert);

    // Se não existir PO no item, ele não entra no contador agrupado.
    if (!PO) return;

    // Se a PO ainda não foi registrada, adiciona ao índice.
    if (groupedAlertsCounter[PO] === undefined) {
      groupedAlertsCounter[PO] = true;
    }
  });

  // A quantidade final é o número de chaves únicas no índice de POs.
  return Object.keys(groupedAlertsCounter).length;
}

// Verifica se um alerta está não lido, cobrindo formatos diferentes do payload.
export function isUnreadAlert(alert = {}) {
  // Normaliza o alerta antes de procurar os campos de leitura.
  const currentAlert = getCurrentAlert(alert);
  // Alguns retornos trazem o status de leitura dentro de user_alerts.
  const userAlerts = currentAlert.user_alerts
    ? currentAlert.user_alerts
    : alert.user_alerts;

  // Quando existe user_alerts[0], o campo `read` indica se já foi lido.
  if (userAlerts && userAlerts[0]) {
    return !userAlerts[0].read;
  }

  // Alguns payloads podem trazer `read` direto no alerta normalizado.
  if (currentAlert.read !== undefined) {
    return !currentAlert.read;
  }

  // Outros podem trazer `read` direto no objeto original.
  if (alert.read !== undefined) {
    return !alert.read;
  }

  // Se nenhum formato conhecido indicar leitura, considera como lido para não inflar contador.
  return false;
}
